/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Err_ConnectionInputs */

const es_footer_err_connection = /** @type {(inputs: Footer_Err_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha ocurrido un error de conexión. Comprueba tu red e inténtalo de nuevo.`)
};

const gl_footer_err_connection = /** @type {(inputs: Footer_Err_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produciuse un erro de conexión. Comproba a túa rede e téntao de novo.`)
};

const en_footer_err_connection = /** @type {(inputs: Footer_Err_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A connection error occurred. Check your network and try again.`)
};

/**
* | output |
* | --- |
* | "A connection error occurred. Check your network and try again." |
*
* @param {Footer_Err_ConnectionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_err_connection = /** @type {((inputs?: Footer_Err_ConnectionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Err_ConnectionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_err_connection(inputs)
	if (locale === "en") return en_footer_err_connection(inputs)
	return es_footer_err_connection(inputs)
});